import { render, staticRenderFns } from "./LeadTimeDetail.vue?vue&type=template&id=4252bec3&scoped=true"
import script from "./LeadTimeDetail.vue?vue&type=script&lang=js"
export * from "./LeadTimeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252bec3",
  null
  
)

export default component.exports